const state = {
  partSearchResults: {
      searchTerm: { type: String, default: ""},
      data: { type: Object, default: {} }
  }
}

const getters = {
  getSearchTerm: (state: { partSearchResults: { searchTerm: String } }) => {
    return state.partSearchResults.searchTerm
  },
  getPartSearchData: (state: { partSearchResults: { data: any } }) => {
    return state.partSearchResults.data
  }
}
const mutations = {
  SET_PART_SEARCH_DATA: function (state: { partSearchResults: any }, partSearchResultsDetails: any) {
    state.partSearchResults = partSearchResultsDetails
    }
}

export default {
  getters,
  state,
  mutations
}
